import { CAP_URL } from 'constants/index';
import { fetchJson } from 'utils/fetchJson/fetchJson';

export const cap = {
  fee: ({ currency }: { currency?: string }) => {
    const url = `${CAP_URL}/fee`;
    const payload = { currency };
    const body = JSON.stringify(payload);
    const options = { method: 'POST', body };

    return fetchJson<{ fee?: number }>(url, options);
  },
};
